<template>
	<div class="deal-links-list">
		<div class="controls">
			<search
				v-if="showSearch"
				@search="onSearch"
				inputPlaceholder="Search by link name"
			/>

			<filters
				v-if="getShowFilters"
				:filters="filters"
				@filter="onFilter"
			/>
		</div>

		<div
			data-element="list"
			v-if="links"
		>
			<deal-link-preview
				v-for="(link, key) in links"
				:key="key"
				:link="link"
			/>
		</div>

		<records-count
			:pagination="pagination"
			:total="totalItems"
		/>
		<pagination
			v-if="showPagination"
			v-bind="pagination"
			@paginate="onPaginate"
		/>
	</div>
</template>

<script>

	import Search from '@/components/ui/views/SearchInput';
	import Filters from '@/components/ui/views/filters/Filters';
	import Pagination from '@/components/ui/views/Pagination';
	import RecordsCount from '@/components/ui/views/RecordsCount';
	import DealLinkPreview from '@/components/dealLinks/DealLinkPreview.vue';

	export default {
		components: {
			DealLinkPreview,
			Search,
			Filters,
			Pagination,
			RecordsCount
		},
		props: {
			showSearch: {
				type: Boolean,
				default: true
			},
			showPagination: {
				type: Boolean,
				default: true
			},
			filters: {
				type: Array,
				default: () => []
			},
			links: {
				type: Array,
				default: undefined
			},
			pagination: {
				type: Object,
				default: () => ({})
			},
			totalItems: {
				type: Number,
				default: undefined
			}
		},
		data: () => {
			return {};
		},
		computed: {
			getShowFilters () {
				return this.filters?.length > 0;
			}
		},
		methods: {
			onSearch (value) {
				this.$emit('search', value);
			},
			onFilter (value) {
				this.$emit('filter', value);
			},
			onPaginate (value) {
				this.$emit('paginate', value);
			}
		}
	};

</script>

<style lang="scss" scoped>

	.deal-links-list {
		margin-bottom: 32px;
		width: 100%;

		.controls {
      display: flex;
      flex-wrap: wrap;

			[data-component='filters'] {
				margin-bottom: 12px;
			}
		}

		[data-element='list'] {
			margin-top: 32px;
		}

		[data-component='records-count'] {
			margin: 12px 0;
		}

		[data-component='pagination'] {
			margin-top: 12px;
		}

		[data-highlight] {
			// modify this to something better when we do UI
			opacity: 0.5;
		}
  }

</style>
